import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import {
  GoBackModule,
  MipAvatarModule,
  MipProfileSlugNameModule
} from '@lib/gc-common';
import { StoriesAvatarsComponent } from './stories-avatars.component';

@NgModule({
  declarations: [StoriesAvatarsComponent],
  imports: [CommonModule, MipAvatarModule, RouterLink, MipProfileSlugNameModule, MatTooltipModule, GoBackModule],
  exports: [
    StoriesAvatarsComponent
  ]
})
export class StoriesAvatarsModule {
}
